import { render, staticRenderFns } from "./CallLogsCreate.vue?vue&type=template&id=4b5fbad5"
import script from "./CallLogsCreate.vue?vue&type=script&lang=ts"
export * from "./CallLogsCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports